import React from 'react';
import { StyleSheet } from 'react-native';
import Animated, { SharedValue, interpolate, useAnimatedStyle, useDerivedValue } from 'react-native-reanimated';

import { Text } from '@/components/TextComponent';
import { ds } from '@/components/lib/design.system';

const AnimatedText = Animated.createAnimatedComponent(Text);

export const TEXT_LINE_HEIGHT = 72;

export const StackedMultiplierText = ({
    multiplier,
    index,
    rotation,
    sliceAngle,
    totalSlices,
}: {
    multiplier: number;
    index: number;
    rotation: SharedValue<number>;
    sliceAngle: number;
    totalSlices: number;
}) => {
    const derrivedValue = useDerivedValue(() => {
        const normalizedDeg = ((rotation.value % 360) + 360) % 360;
        const offsetDeg = (normalizedDeg - sliceAngle / 2) % 360;
        const currentIndex = Math.floor((totalSlices - offsetDeg / sliceAngle) % totalSlices);
        return currentIndex === index ? 1 : 0;
    }, [index]);

    const animatedStyle = useAnimatedStyle(() => {
        return {
            opacity: interpolate(derrivedValue.value, [0, 1], [0, 1]),
        };
    });
    const multiplierText = `${multiplier}X`;

    return <AnimatedText style={[animatedStyle, styles.text]}>{multiplierText}</AnimatedText>;
};

const styles = StyleSheet.create({
    text: {
        position: 'absolute',
        textAlign: 'center',
        fontFamily: 'gamay-extrabold',
        fontSize: TEXT_LINE_HEIGHT,
        fontWeight: '600',
        lineHeight: TEXT_LINE_HEIGHT,
        color: ds.colorValue.text.primary,
    },
});
